import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from '../../../common/constants';
import { updateCapEndpointUrl } from '../../../config';
import api from '../../../api';
import { RootState } from '../../../store';

export interface IUpdateCapEndpointPayload {
  endpointId: string;
  name?: string;
  groups?: { id: string; displayName: string }[];
  templateId?: number;
  isActive?: boolean;
}

interface IUpdateCapEndpointState {
  status: string;
  error: string | null;
}

const initialState: IUpdateCapEndpointState = {
  status: Status.IDLE,
  error: null,
};

export const updateCapEndpoint: any = createAsyncThunk(
  'updateCapEndpoint',
  async (payload: IUpdateCapEndpointPayload, { rejectWithValue }) => {
    try {
      const response = await api.put(updateCapEndpointUrl, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const updateCapEndpointSlice = createSlice({
  name: 'updateCapEndpoint',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateCapEndpoint.pending, (state) => {
        state.status = Status.PENDING;
        state.error = null;
      })
      .addCase(updateCapEndpoint.fulfilled, (state) => {
        state.status = Status.SUCCESS;
      })
      .addCase(updateCapEndpoint.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { message?: string } } };
        state.status = Status.FAILED;
        state.error = errorPayload?.response?.data?.message || action.error.message || 'Unknown error';
      });
  },
});

export const selector = (state: RootState) => state.updateCapEndpoint;
export default updateCapEndpointSlice.reducer;
